import {ref, onUnmounted, onMounted} from 'vue'
import { registerSW } from 'virtual:pwa-register'

export interface PwaUpdateOptions {
    enablePolling?: boolean
    pollingInterval?: number
}

export interface PwaUpdateEvents {
    onUpdateDetected?: () => void
}

export function usePwaUpdate(
    events?: PwaUpdateEvents,
    options: PwaUpdateOptions = {}
) {
    const isUpdateAvailable = ref(false)

    const applySWUpdate = registerSW({
        immediate: false,

        onNeedRefresh() {
            isUpdateAvailable.value = true
            events?.onUpdateDetected?.()
        },

        onOfflineReady() {
            // opcional
        }
    })

    async function applyUpdate() {
        const onControllerChange = () => {
            navigator.serviceWorker.removeEventListener(
                'controllerchange',
                onControllerChange
            )
            window.location.reload()
        }

        navigator.serviceWorker.addEventListener(
            'controllerchange',
            onControllerChange
        )

        await applySWUpdate(false)
    }

    let intervalId: number | null = null

    onMounted(() => {
        if (!options.enablePolling) return

        const interval = options.pollingInterval ?? 5 * 60 * 1000

        intervalId = window.setInterval(async () => {
            if (!navigator.onLine) return
            if (isUpdateAvailable.value) return

            try {
                const registration =
                    await navigator.serviceWorker.getRegistration()
                await registration?.update()
            } catch {
                // silencioso por design
            }
        }, interval)
    })

    onUnmounted(() => {
        if (intervalId) clearInterval(intervalId)
    })

    return {
        isUpdateAvailable,
        applyUpdate
    }
}